import Repository from "@/plugins/axios";

export default {
  // Получить контакты
  getContacts() {
    return Repository.get(`/biennale/contacts`);
  },
};
